import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip);

const CircleGraph = ({ correctQuestions, wrongQuestions }) => {
    const total = correctQuestions + wrongQuestions;
    const pct = total > 0 ? Math.round((correctQuestions / total) * 100) : 0;

    const data = {
        datasets: [{
            data: total > 0 ? [correctQuestions, wrongQuestions] : [1, 0],
            backgroundColor: total > 0
                ? ['rgba(100, 116, 139, 0.7)', 'rgba(203, 213, 225, 0.4)']
                : ['rgba(203,213,225,0.3)'],
            borderColor: total > 0
                ? ['rgba(100, 116, 139, 0.3)', 'rgba(203, 213, 225, 0.2)']
                : ['rgba(203,213,225,0.2)'],
            borderWidth: 1,
            hoverBackgroundColor: ['#34d399', '#f87171'],
            borderRadius: 6,
            spacing: 3,
        }],
    };

    const options = {
        plugins: {
            tooltip: { enabled: false },
            legend: { display: false },
        },
        cutout: '72%',
        maintainAspectRatio: false,
        animation: { duration: 900, easing: 'easeOutQuart' },
    };

    return (
        <div className="relative flex flex-col items-center">
            <div className="relative" style={{ width: '100px', height: '100px' }}>
                <Doughnut data={data} options={options} />
                <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
                    <span className="text-lg font-bold tabular-nums text-slate-700">{pct}%</span>
                    <span className="text-[9px] text-slate-400 tracking-wider uppercase">correct</span>
                </div>
            </div>
            <div className="flex items-center gap-3 mt-1.5">
                <span className="flex items-center gap-1 text-[10px] text-slate-400">
                    <span className="w-1.5 h-1.5 rounded-full bg-slate-500 inline-block" />
                    {correctQuestions}
                </span>
                <span className="flex items-center gap-1 text-[10px] text-slate-400">
                    <span className="w-1.5 h-1.5 rounded-full bg-slate-300 inline-block" />
                    {wrongQuestions}
                </span>
            </div>
        </div>
    );
};

export default CircleGraph;
